export function getAge(dateString) {
    let today = new Date();
    let birthDate = new Date(dateString);

    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
 }

export function personValidate(obj, ageMin = 3, ageMax = 65) {
    const errors = {};
    const cyrillicAndNums = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()\d]+$/;
    const cyrillic = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
    const latin = /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
    const email = /^[a-zA-Z0-9._-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/;

    // Фамилия
    if (!obj.last_name) {
      errors.last_name = 'укажите фамилию';
    } else if (!cyrillic.test(obj.last_name)) {
      errors.last_name = 'допустимы только символы кириллицы';
    }

    // Имя
    if (!obj.first_name) {
      errors.first_name = 'укажите имя';
    } else if (!cyrillic.test(obj.first_name)) {
      errors.first_name = 'допустимы только символы кириллицы';
    }

    // Отчество
    if (!obj.has_middle_name) {
        if (!obj.middle_name) {
          errors.middle_name = 'укажите отчество';
        } else if (!cyrillic.test(obj.middle_name)) {
          errors.middle_name = 'допустимы только символы кириллицы';
        }
    }

    // Дата рождения
    if (!obj.birth_date) {
      errors.birth_date = 'укажите корректную дату рождения';
    } else if (getAge(obj.birth_date) < 3) {
      errors.birth_date = `минимальный возраст ${ageMin} ${ageMin < 5 ? 'года' : 'лет'}`;
    } else if (getAge(obj.birth_date) > 65) {
      errors.birth_date = `максимальный возраст ${ageMax} лет включительно`;
    }

    // Телефон
    if (obj.hasOwnProperty('phone') && !obj.phone) {
      errors.phone = 'укажите номер телефона';
    } else if (obj.phone && obj.phone.length < 18) {
      errors.phone = 'укажите номер телефона полностью';
    }

    // Электронная почта
    if (obj.hasOwnProperty('email') && !obj.email) {
      errors.email = 'укажите адрес электронной почты';
    } else if (obj.email && !email.test(obj.email)) {
      errors.email = 'укажите корректный адрес электронной почты';
    }

    return errors
  }